const decodeBase64Url = (value) => {
  const normalized = value.replace(/-/g, '+').replace(/_/g, '/');
  const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, '=');
  return window.atob(padded);
};

export const decodeJwtPayload = (token) => {
  if (!token || typeof token !== 'string') {
    return null;
  }
  const parts = token.split('.');
  if (parts.length < 2) {
    return null;
  }
  try {
    return JSON.parse(decodeBase64Url(parts[1]));
  } catch {
    return null;
  }
};

export const getCognitoGroupsFromPayload = (payload) => {
  const groups = payload?.['cognito:groups'];
  if (Array.isArray(groups)) {
    return groups;
  }
  if (typeof groups === 'string' && groups.trim().length > 0) {
    return [groups];
  }
  return [];
};

export const getCurrentUserId = () => {
  try {
    const token = sessionStorage.getItem('idToken')
      || sessionStorage.getItem('accessToken')
      || sessionStorage.getItem('token');
    const payload = decodeJwtPayload(token);
    const id = payload?.sub
      || payload?.['cognito:username']
      || payload?.preferred_username
      || payload?.email;
    if (id) {
      return String(id);
    }
  } catch {
    // ignore storage/parse errors
  }
  return 'anonymous';
};

export const isFodRole = (roles) => Array.isArray(roles) && roles.includes('FOD');
export const isChapeaRole = (roles) => Array.isArray(roles) && roles.includes('CHAPEA');

export const getStoredRoles = () => {
  try {
    const raw = sessionStorage.getItem('userRoles');
    if (!raw) {
      return [];
    }
    const parsed = JSON.parse(raw);
    if (Array.isArray(parsed)) {
      return parsed;
    }
  } catch {
    return [];
  }
  return [];
};
